<template>
    <!-- header start -->
    <section class="order_review_header">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div
                        class="order_review_logo d-flex align0items-center flex-wrap"
                    >
                        <a @click="$router.back()">
                            <img
                                src="/maincss/images/orderproofreview_logo.svg"
                                alt=""
                                class="opr_logo_img"
                            />
                            <img
                                src="/maincss/images/artwork_proof.png"
                                alt=""
                                class="opr_artwork_img"
                            />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- header end -->
</template>

<script setup></script>
